export const Footer = () => {
    return (
        <footer>
          <span>
            <nav className='footer-menu'>
              <a href="/register" title="Sign up">Sign up</a>
              <a href="/" title="About">About</a>
              <a href="/terms-of-service" title="Terms of Service">Terms of Service</a>
              <a href="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
            </nav>
          </span>
          <span>
            Copyright © 2025 Brather LTD
          </span>
          <span>
            Website by <a href="https://queerwebdesign.com" title="Queer Web Design" target="_blank" rel="noopener noreferrer">Queer Web Design</a>
          </span>
        </footer>
    )
}